import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppFile } from 'taxtank-core';
import {
  AbstractFileUploaderControlComponent
} from '@shared/component/form-controls/file/abstract-file-uploader-control/abstract-file-uploader-control.component';

@Component({
  selector: 'app-multiple-file-uploader',
  templateUrl: '../abstract-file-uploader-control/abstract-file-uploader-control.component.html',
  styleUrl: '../abstract-file-uploader-control/abstract-file-uploader-control.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

export class MultipleFileUploaderComponent extends AbstractFileUploaderControlComponent<AppFile[]> implements OnInit, AfterViewInit {
  multiple = true;

  protected updateValue(files: AppFile[]): void {
    this.value = [...this.value, ...files];
  }

  delete(deleteFile: AppFile): void {
    this.value = this.value.filter(file => file !== deleteFile);
    this.onChange(this.value);
  }

  protected get isEmpty(): boolean {
    return this.value.length === 0;
  }
}
